// extracted by mini-css-extract-plugin
module.exports = {"searchContent":"kx","content":"ky","navigation":"kz","mainPanel":"kA","footer":"kB"};